const isValidCPF = (cpf: string): boolean => {
    cpf = cpf?.replace(/[^\d]+/g, '');

    if (cpf?.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;

    let sum = 0;
    let remainder;

    for (let i = 1; i <= 9; i++) sum += parseInt(cpf.substring(i - 1, i)) * (11 - i);
    remainder = (sum * 10) % 11;

    if (remainder === 10 || remainder === 11) remainder = 0;
    if (remainder !== parseInt(cpf.substring(9, 10))) return false;

    sum = 0;
    for (let i = 1; i <= 10; i++) sum += parseInt(cpf.substring(i - 1, i)) * (12 - i);
    remainder = (sum * 10) % 11;

    if (remainder === 10 || remainder === 11) remainder = 0;
    if (remainder !== parseInt(cpf.substring(10, 11))) return false;

    return true;
};

const isValidCNPJ = (cnpj: string): boolean => {
    cnpj = cnpj?.replace(/[^\d]+/g, '');
  
    if (cnpj?.length !== 14 || /^(\d)\1{13}$/.test(cnpj)) return false;
  
    const calcVerifier = (base: string, weightStart: number): number => {
      let sum = 0;
      let weight = weightStart;
  
      for (let i = 0; i < base.length; i++) {
        sum += parseInt(base.charAt(i)) * weight;
        weight--;
        if (weight < 2) weight = 9;
      }
  
      const remainder = sum % 11;
      return remainder < 2 ? 0 : 11 - remainder;
    };
  
    const base = cnpj.slice(0, 12);
    const digit1 = calcVerifier(base, 5);
    const digit2 = calcVerifier(base + digit1, 6);
  
    return cnpj === base + digit1.toString() + digit2.toString();
  };


  const isValidCpfOrCnpj = (value: string): boolean => {
    const cleanValue = value.replace(/[^\d]+/g, '');
    return isValidCPF(cleanValue) || isValidCNPJ(cleanValue);
    
  };

const checkIsMinor = (birthdate: string): boolean => {
  if (!birthdate || birthdate.length < 10) return false;
  const [day, month, year] = birthdate.split("/").map(Number);
  if (!day || !month || !year) return false;
  const d = new Date(year, month - 1, day);
  if (isNaN(d.getTime())) return false;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const limit = new Date(today);
  limit.setFullYear(today.getFullYear() - 18);
  return d > limit;
};

export { isValidCpfOrCnpj, isValidCPF, isValidCNPJ, checkIsMinor }